module.exports = {
	"ha": "bc",
	"id": 5.3,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginLeft": 90,
			"marginTop": 60,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 67.8916827852998,
						"dataLabels": {
							"enabled": true,
							"format": "351",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 56.09284332688588,
						"dataLabels": {
							"enabled": true,
							"format": "290",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.22437137330754,
						"dataLabels": {
							"enabled": true,
							"format": "270",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 46.808510638297875,
						"dataLabels": {
							"enabled": true,
							"format": "242",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 38.297872340425535,
						"dataLabels": {
							"enabled": true,
							"format": "198",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 92.279138827023,
						"dataLabels": {
							"enabled": true,
							"format": "1243",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76.76317743132887,
						"dataLabels": {
							"enabled": true,
							"format": "1034",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.60133630289532,
						"dataLabels": {
							"enabled": true,
							"format": "951",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.1380846325167,
						"dataLabels": {
							"enabled": true,
							"format": "837",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 51.521900519673345,
						"dataLabels": {
							"enabled": true,
							"format": "694",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 93.34160463192721,
						"dataLabels": {
							"enabled": true,
							"format": "2257",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75.43424317617865,
						"dataLabels": {
							"enabled": true,
							"format": "1824",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.26468155500413,
						"dataLabels": {
							"enabled": true,
							"format": "1699",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.2266335814723,
						"dataLabels": {
							"enabled": true,
							"format": "1553",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 51.44747725392887,
						"dataLabels": {
							"enabled": true,
							"format": "1244",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 93.6910569105691,
						"dataLabels": {
							"enabled": true,
							"format": "5762",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.64227642276423,
						"dataLabels": {
							"enabled": true,
							"format": "4775",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.44715447154472,
						"dataLabels": {
							"enabled": true,
							"format": "4517",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.65853658536585,
						"dataLabels": {
							"enabled": true,
							"format": "4284",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.609756097560975,
						"dataLabels": {
							"enabled": true,
							"format": "3666",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -32.108317214700186,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.37891737891738,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.896551724137934,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.370370370370374,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.181818181818176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -7.720861172976989,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.814159292035402,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.027079303675045,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.987381703470035,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.08482676224612,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -6.658395368072789,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.18475852902083,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.853070175438591,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.59329017068864,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.89697359948487,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -6.308943089430896,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.129468934397774,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.403141361256547,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.158290901040519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.425770308123253,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=517"
			},
			{
				"x": 9,
				"text": "30–39<br>n=1347"
			},
			{
				"x": 15,
				"text": "40–49<br>n=2418"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=6150"
			}
		],
		"dataTable": {
			"< 30": [
				517,
				351,
				290,
				270,
				242,
				198
			],
			"30–39": [
				1347,
				1243,
				1034,
				951,
				837,
				694
			],
			"40–49": [
				2418,
				2257,
				1824,
				1699,
				1553,
				1244
			],
			"≥ 50": [
				6150,
				5762,
				4775,
				4517,
				4284,
				3666
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_3.json
// module id = 166
// module chunks = 0